import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=1d0051e6&"
import script from "./DefaultHeader.vue?vue&type=script&lang=ts&"
export * from "./DefaultHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports